
import { ads } from "~/utils/constants.js";
import Vue from "vue";
Vue.config.ignoredElements = ["zone"];
export default {
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      isMobile: false,
      ads,
      footers: [
        {
          title: "Chọn trường",
          linkTo: "/chon-truong",
        },
        {
          title: "Ngành học",
          linkTo: "/nganh-hoc",
        },
        {
          title: "Điểm chuẩn",
          linkTo: "/diem-chuan?range=all&year=2025",
        },
        {
          title: "Sự kiện",
          linkTo: "/sukien",
        },
      ],
      socials: [
        {
          name: "Facebook",
          src: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/4631826c0d884bdb95a8657c5ff558f8.png`,
          linkto: "https://www.facebook.com/baotuoitre/?locale=vi_VN",
        },
        {
          name: "Instagram",
          src: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/e9c7d37f5b314a2fb032da5acb96da94.png`,
          linkto: "https://www.instagram.com/baotuoitre/?hl=en",
        },

        {
          name: "LinkedIn",
          src: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/3e5efad6d085486fb081810b4e63a968.png`,
          linkto: "https://vn.linkedin.com/in/baotuoitre",
        },
        {
          name: "Twitter",
          src: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/0fb65979bfd945808ba40e92a3a4f930.png`,
          linkto: "https://twitter.com/bao_tuoitre",
        },
      ],
    };
  },
  mounted() {
    if (window.innerWidth < 736) {
      this.isMobile = true;
    }

    var arfAsync = window.arfAsync || [];
    arfAsync.push(this.ads.pc.ballon);
    arfAsync.push(this.ads.mobile.cashfish);
  },
};
